import { BeneficiaryType } from '@seapoint/server/enums';
import { DataTable } from '../../../../design-system/data-table/data-table';
import {
  financialInformationTableColumnDefinition,
  PayrollEmployee,
} from './financial-information-table-column-definition';

export const FinancialInformationTable = ({
  employees,
  onReferenceChange,
  onNetPayChange,
}: {
  employees: PayrollEmployee[];
  onReferenceChange?: (employeeId: string, reference: string) => void;
  onNetPayChange?: (employeeId: string, netPay: string) => void;
  currencySymbol?: string;
}) => {
  return (
    <DataTable<PayrollEmployee>
      columns={financialInformationTableColumnDefinition}
      data={employees}
      className="w-full"
      meta={{
        rowHeight: 76,
        showAccountOptions: employees.some((employee) => employee.destination?.type === BeneficiaryType.SCAN),
        onReferenceChange,
        onNetPayChange,
      }}
    />
  );
};
